import React, { useEffect, useState } from "react";
import { Badge, Modal, Spinner, Table } from "react-bootstrap";
import axiosInstance from "../services/axiosInterceptor";

const API = process.env.REACT_APP_API;

// รายชื่อนักเรียนที่ยังไม่มีเกรดของหนึ่งการสอน (วิชา × ห้อง) — ติด ร หรือยังไม่มีคะแนน
// ใช้ร่วมกันระหว่างรายงานการส่งเกรดกับหน้าภาพรวมกลุ่มสาระ
// row = แถวจาก getGradeSubmissionByYear (หรือ null = ปิด)
export default function MissingGradesModal({ row, onHide }) {
  const [state, setState] = useState({ list: [], loading: false, error: false });

  useEffect(() => {
    if (!row) return;
    let alive = true;
    setState({ list: [], loading: true, error: false });
    axiosInstance.get(`${API}/getGradeSubmissionMissing/${row.teach_id}`)
      .then(res => { if (alive) setState({ list: res.data || [], loading: false, error: false }); })
      .catch(() => { if (alive) setState({ list: [], loading: false, error: true }); });
    return () => { alive = false; };
  }, [row]);

  return (
    <Modal show={!!row} onHide={onHide} size="lg" scrollable>
      <Modal.Header closeButton>
        <Modal.Title as="h6">
          {row && (
            <>
              นักเรียนที่ยังไม่มีเกรด · <span className="text-muted">{row.sub_subid}</span> {row.sub_subname} · ม.{row.class_room} · ภาค {row.sub_semester}
              <div className="fs-sm text-muted fw-normal mt-1">ครูผู้สอน: {row.t_name} · มีเกรดแล้ว {row.graded_count}/{row.total_students} คน</div>
            </>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        {state.loading ? (
          <div className="text-center py-4"><Spinner animation="border" size="sm" /></div>
        ) : state.error ? (
          <div className="text-center text-danger py-4">โหลดรายชื่อไม่สำเร็จ</div>
        ) : state.list.length === 0 ? (
          <div className="text-center text-muted py-4">ไม่มีนักเรียนที่ขาดเกรด</div>
        ) : (
          <Table hover size="sm" className="mb-0">
            <thead className="table-secondary">
              <tr>
                <th className="text-center" style={{ width: 50 }}>#</th>
                <th>เลขประจำตัว</th>
                <th>ชื่อ-สกุล</th>
                <th className="text-center">สถานะ</th>
                <th className="text-center">ช่องคะแนนที่กรอกแล้ว</th>
                <th className="text-center">คะแนนสะสม</th>
              </tr>
            </thead>
            <tbody>
              {state.list.map((s, i) => (
                <tr key={s.study_id}>
                  <td className="text-center">{i + 1}</td>
                  <td>{s.st_idnumber}</td>
                  <td>{s.st_name}</td>
                  <td className="text-center">
                    {s.state === 'waiting'
                      ? <Badge bg="warning" text="dark">ติด ร</Badge>
                      : <Badge bg="secondary">ไม่มีคะแนน</Badge>}
                  </td>
                  <td className="text-center">{s.item_total > 0 ? `${s.item_filled}/${s.item_total}` : <span className="text-muted">ยังไม่ตั้งช่องคะแนน</span>}</td>
                  <td className="text-center">{s.g_grade ?? <span className="text-muted">-</span>}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>
    </Modal>
  );
}
